import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ErrorBannerConfig {
  show: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorBannerService {
  private bannerSubject = new BehaviorSubject<ErrorBannerConfig>({
    show: false,
  });

  private isServiceDown = false;

  public banner$ = this.bannerSubject.asObservable();

  get isDown(): boolean {
    return this.isServiceDown;
  }

  showServiceUnavailableBanner(): void {
    this.isServiceDown = true;
    this.bannerSubject.next({
      show: true,
    });
  }

  hideBanner(): void {
    this.isServiceDown = false;
    this.bannerSubject.next({
      show: false,
    });
  }

  refreshPage(): void {
    window.location.reload();
  }
}
